import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { ExportQuery, ExportQueryParameters, ExportResult } from '@skylab-shared/business';
import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { extractFilenameFromHeaders, MS_PER_MINUTE } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';

export interface ProductsEppExportParameters extends ExportQueryParameters { search: string; }

export class ProductsEppExportQuery extends ExportQuery<ExportResult> {
    constructor(parameters: ExportQueryParameters) {
        super(parameters);
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductsEppExportQuery)
export class ProductsEppExportQueryHandler implements QueryHandler<ProductsEppExportQuery, ExportResult> {
    #Url = TaggedUrl.join('products/epp/export', [Tags.Api]);
    #http =  inject(Http) as HttpService;

    async handleAsync({ parameters }: ProductsEppExportQuery): Promise<ExportResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns
            }
        };

        const response = await this.#http.post<Blob>(this.#Url, requestData, { responseType: 'blob', timeout: 3 * MS_PER_MINUTE });

        return {
            file: response.data,
            filename: extractFilenameFromHeaders(<AxiosResponse>response) ?? ''
        };
    }
}
